<template>
  <div class="formula">
    <!-- 配方类型选择组 -->
    <a-radio-group v-model="selectedFormulaType" class="formula-radio-group">
      <!-- 第一行：我的配方 -->
      <div class="formula-row" style="margin-bottom: 16px;">
        <a-radio value="my" class="formula-radio">
          <span class="formula-label">我的配方</span>
          <a-tooltip placement="top" :title="'在配方管理、混合日粮模块中，配方师创建并管理的配方'">
            <a-icon type="question-circle" style="margin-left: 4px;color: #999;" />
          </a-tooltip>
        </a-radio>
        <a-select 
          style="width: 200px; margin-left: 8px;" 
          :default-active-first-option="false" 
          :filter-option="false"
          :not-found-content="null" 
          @change="onFormulaTypeChange" 
          v-model="formulaType"
          :disabled="selectedFormulaType !== 'my'">
          <a-select-option v-for="d in searchList" :key="d.code">
            {{ d.name }}
          </a-select-option>
        </a-select>
        <a-input 
          style="width: 200px; margin-left: 8px;" 
          v-model="formulaKeyword" 
          @change="e => keyChange(e)" 
          placeholder="配方名称/配方代码"
          @pressEnter="onKeywordSearch"
          :disabled="selectedFormulaType !== 'my'" />
      </div>
      
      <!-- 第二行：代工配方 -->
      <div class="formula-row" style="margin-bottom: 16px;" v-if="isOemVisible">
        <a-radio value="oem" class="formula-radio">
          <span class="formula-label">代工配方</span>
          <a-tooltip placement="top" :title="'在代工配方模块中，品管经理和配方师创建并管理的配方'">
            <a-icon type="question-circle" style="margin-left: 4px;color: #999;" />
          </a-tooltip>
        </a-radio>
        <a-select 
          style="width: 200px; margin-left: 8px;" 
          :default-active-first-option="false" 
          :filter-option="false"
          :not-found-content="null" 
          @change="onSecondFormulaTypeChange" 
          v-model="secondFormulaType"
          :disabled="selectedFormulaType !== 'oem'">
          <a-select-option v-for="d in oemSearchList" :key="d.code">
            {{ d.name }}
          </a-select-option>
        </a-select>
        <a-input 
          style="width: 200px; margin-left: 8px;" 
          v-model="secondFormulaKeyword" 
          @change="e => secondKeyChange(e)"
          placeholder="配方名称/配方代码" 
          @pressEnter="onSecondKeywordSearch"
          :disabled="selectedFormulaType !== 'oem'" />
      </div>

      <!-- 第三行：关联配方（仅配方师可见） -->
      <div class="formula-row" style="margin-bottom: 16px;" v-if="isLinkedVisible">
        <a-radio value="linked" class="formula-radio">
          <span class="formula-label">关联配方</span>
          <a-tooltip placement="top" :title="'其他产业配方师通过关联工厂功能推送到当前工厂中生产执行的配方。'">
            <a-icon type="question-circle" style="margin-left: 4px;color: #999;" />
          </a-tooltip>
        </a-radio>
        <a-input 
          style="width: 200px; margin-left: 8px;" 
          v-model="linkedFormulaKeyword" 
          @change="e => linkedKeyChange(e)"
          placeholder="配方名称/配方代码" 
          @pressEnter="onLinkedKeywordSearch"
          :disabled="selectedFormulaType !== 'linked'" />
      </div>

      <!-- 第四行：工厂配方 -->
      <div class="formula-row" style="margin-bottom: 16px;" v-if="isLinkedVisible">
        <a-radio value="fourth" class="formula-radio">
          <span class="formula-label">工厂配方</span>
          <a-tooltip placement="top" :title="'工厂配方'">
            <a-icon type="question-circle" style="margin-left: 4px;color: #999;" />
          </a-tooltip>
        </a-radio>
        <a-select 
          style="width: 200px; margin-left: 8px;" 
          :default-active-first-option="false" 
          :filter-option="false"
          show-search
          @change="onFourthFormulaTypeChange" 
          v-model="lineId"
          allow-clear
          placeholder="选择线路"
          :disabled="selectedFormulaType !== 'fourth'">
          <a-select-option v-for="d in fourthSearchList" :key="d.id" :value="d.id">
            {{ d.name }}
          </a-select-option>
        </a-select>
        <a-select 
          style="width: 200px; margin-left: 8px;" 
          :default-active-first-option="false" 
          :filter-option="false"
          show-search
          @search="onFormulatorSearch"
          @change="onFormulatorChange" 
          v-model="formulatorId"
          allow-clear
          placeholder="选择配方师"
          :disabled="selectedFormulaType !== 'fourth'">
          <a-select-option v-for="d in formulatorList" :key="d.staffId" :value="d.staffId">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </div>
    </a-radio-group>
    
    <a-table ref="listRef" :scroll="{ y }" class="tableBox" :columns="columns" :data-source="list"
      :pagination="pagination" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      rowKey="id">
    </a-table>
    <div style="margin-top: 12px; color: #666;">
      {{ selectedCountText }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    drwaerObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    selectedCountText() {
      const count = Object.keys(this.selectedRowsMap || {}).length
      return `已选中 ${count} 个配方`
    }
  },
  data() {
    return {
      selectedFormulaType: 'my', // 当前选中的配方类型：'my' 或 'oem'
      formulaKeyword: undefined,
      formulaType: null,  //初始化默认值为undefined，同时显示"配合饲料"，"混合日粮"数据
      secondFormulaKeyword: undefined,
      secondFormulaType: '5',  // 第二个搜索控件固定为代工配方
      linkedFormulaKeyword: undefined,
      fourthFormulaKeyword: undefined,
      lineId: undefined,
      formulatorId: undefined,
      searchList: [{ code: null, name: '所有配方' }, { code: '1', name: '配合饲料' }, { code: '2', name: '混合日粮' }, { code: '5', name: '代工配方' }],
      oemSearchList: [{ code: '5', name: '代工配方' }],
      fourthSearchList: [],
      formulatorList: [],
      formulatorSearchTimer: null,
      addVisible: false,
      y: 240,
      columns: [
        { title: '配方代码', dataIndex: 'formulaCode' },
        { title: '配方名称', dataIndex: 'formulaName' },
        { title: '动物类型', dataIndex: 'animalTypeName' },
        { title: '工厂名称', dataIndex: 'factoryName' },
        { title: '用户名称', dataIndex: 'createUserName' },
      ],
      selectedRowKeys: [],
      // 使用 Map 缓存已选项，支持跨页/跨类型保留勾选
      selectedRowsMap: {}, // { [id]: row }
      list: [],
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.pagination.pageSize = pageSize
          if (this.selectedFormulaType === 'my') {
            this.getList({ current, pageSize })
          } else if (this.selectedFormulaType === 'oem') {
            this.getOemList({ current, pageSize })
          } else if (this.selectedFormulaType === 'linked') {
            this.getLinkedList({ current, pageSize })
          } else if (this.selectedFormulaType === 'fourth') {
            this.getFourthList({ current, pageSize })
          }
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          if (this.selectedFormulaType === 'my') {
            this.getList({ current: 1, pageSize })
          } else if (this.selectedFormulaType === 'oem') {
            this.getOemList({ current: 1, pageSize })
          } else if (this.selectedFormulaType === 'linked') {
            this.getLinkedList({ current: 1, pageSize })
          } else if (this.selectedFormulaType === 'fourth') {
            this.getFourthList({ current: 1, pageSize })
          }
        } //每页多少条
      },
      timer: null,
      // 是否显示“代工配方”选项：仅当当前工厂中用户角色为“(饲料BU)配方师”时显示
      isOemVisible: false,
      // 是否显示"关联配方"和"工厂配方"选项：仅当当前工厂中用户角色为"(饲料BU)配方师"时显示
      isLinkedVisible: false,
    }
  },
  mounted() {
    this.getList()
    this.fetchUserRole()
  },
  watch: {
    selectedFormulaType(newVal) {
      // 当切换配方类型时，重新获取数据
      if (newVal === 'my') {
        this.getList()
      } else if (newVal === 'oem') {
        this.secondFormulaType = '5'
        this.getOemList()
      } else if (newVal === 'linked') {
        this.getLinkedList()
      } else if (newVal === 'fourth') {
        this.getFourthList()
      }
    }
  },
  methods: {
    keyChange() {
      if (this.timer) { clearTimeout(this.timer); }
      this.timer = setTimeout(() => {
        if (this.selectedFormulaType === 'my') {
          this.getList()
        } else if (this.selectedFormulaType === 'oem') {
          this.getOemList()
        } else if (this.selectedFormulaType === 'linked') {
          this.getLinkedList()
        } else if (this.selectedFormulaType === 'fourth') {
          this.getFourthList()
        }
        this.timer = null;
      }, 300)
    },
    // 关联配方列表查询
    getLinkedList(pagination) {
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let params = {
        factoryId: window.localStorage.getItem('factoryId'),
        forecastId: this.drwaerObj.id,
        current,
        size: pageSize,
        searchKey: this.linkedFormulaKeyword,
      }
      // 暂无已知接口，按命名约定占位，如需调整请告知
      this.$http.get('/nhf-app/productiondetail/correlationFormulaQueryWithoutExist', { params }).then(res => {
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
          // 保持全局选中 keys，避免提交时丢失其它页的选择
          this.selectedRowKeys = Object.keys(this.selectedRowsMap)
        }
      })
    },
      // OEM 配方列表查询（第二个搜索控件）
      getOemList(pagination) {
        let { current = 1, pageSize = 20 } = pagination || this.pagination
        let params = {
          factoryId: window.localStorage.getItem('factoryId'),
          forecastId: this.drwaerObj.id,
          formulaType: this.secondFormulaType,
          current,
          size: pageSize,
          searchKey: this.secondFormulaKeyword,
        }
        this.$http.get('/nhf-app/productiondetail/oemFormulaQueryWithoutExist', { params }).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0 } = data;
            this.pagination.current = current
            this.pagination.total = total
            this.list = records || []
            // 保持全局选中 keys，避免提交时丢失其它页的选择
            this.selectedRowKeys = Object.keys(this.selectedRowsMap)
          }
        })
      },
    getList(pagination) {
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let params = {
        factoryId: window.localStorage.getItem('factoryId'),
        forecastId: this.drwaerObj.id,
        formulaType: this.formulaType, current, size: pageSize,
        searchKey: this.formulaKeyword,
      }
      this.$http.get('/nhf-app/productiondetail/formula/queryWithoutExsit', { params }).then(res => {
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
          // 保持全局选中 keys，避免提交时丢失其它页的选择
          this.selectedRowKeys = Object.keys(this.selectedRowsMap)
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      // 当前页的所有 id
      const currentPageIds = (this.list || []).map(r => r.id)
      // 将当前页面未勾选的从全量中移除（处理反选）
      const currentPageSelectedSet = new Set(selectedRowKeys)
      currentPageIds.forEach(id => {
        if (!currentPageSelectedSet.has(id)) {
          // 仅当该 id 在当前页且未被勾选时，从 map 和 keys 中移除
          if (this.selectedRowsMap[id]) this.$delete(this.selectedRowsMap, id)
        }
      });

      // 合并：把当前页新勾选的加入缓存
      (this.list || []).forEach(row => {
        if (currentPageSelectedSet.has(row.id)) {
          this.$set(this.selectedRowsMap, row.id, row)
        }
      })

      // 重新计算全量选中 keys（用于保持其它页勾选状态）
      this.selectedRowKeys = Object.keys(this.selectedRowsMap)
    },
    showAdd() {
      this.addVisible = true
    },
    addSubmit() {
      console.log('addSubmit')
    },
    showAddFunc() {
      console.log('showAddFunc')
    },
    onSearch() {
      if (this.selectedFormulaType === 'my') {
        this.getList({ current: 1, pageSize: this.pagination.pageSize })
      } else if (this.selectedFormulaType === 'oem') {
        this.getOemList({ current: 1, pageSize: this.pagination.pageSize })
      } else if (this.selectedFormulaType === 'linked') {
        this.getLinkedList({ current: 1, pageSize: this.pagination.pageSize })
      } else if (this.selectedFormulaType === 'fourth') {
        this.getFourthList({ current: 1, pageSize: this.pagination.pageSize })
      }
    },
    // 第一个搜索控件的事件处理
    onFormulaTypeChange() {
      this.getList({ current: 1, pageSize: this.pagination.pageSize })
    },
    onKeywordSearch() {
      this.getList({ current: 1, pageSize: this.pagination.pageSize })
    },
    // 第二个搜索控件的事件处理
    onSecondFormulaTypeChange() {
      this.getOemList({ current: 1, pageSize: this.pagination.pageSize })
    },
    onSecondKeywordSearch() {
      this.getOemList({ current: 1, pageSize: this.pagination.pageSize })
    },
    secondKeyChange() {
      if (this.timer) { clearTimeout(this.timer); }
      this.timer = setTimeout(() => {
        this.getOemList()
        this.timer = null;
      }, 300)
    },
    onLinkedKeywordSearch() {
      this.getLinkedList({ current: 1, pageSize: this.pagination.pageSize })
    },
    linkedKeyChange() {
      if (this.timer) { clearTimeout(this.timer); }
      this.timer = setTimeout(() => {
        this.getLinkedList()
        this.timer = null;
      }, 300)
    },
    // 第四行事件处理
    onFourthFormulaTypeChange(value) {
      this.lineId = value
      this.getFourthList({ current: 1, pageSize: this.pagination.pageSize })
    },
    // 配方师选择变化
    onFormulatorChange(value) {
      this.formulatorId = value
      // 清空时重新加载当前工厂下全部配方师列表
      if (!value) {
        this.fetchFormulatorList()
      }
      this.getFourthList({ current: 1, pageSize: this.pagination.pageSize })
    },
    // 配方师模糊搜索（防抖 300ms）
    onFormulatorSearch(value) {
      if (this.formulatorSearchTimer) { clearTimeout(this.formulatorSearchTimer) }
      this.formulatorSearchTimer = setTimeout(() => {
        this.fetchFormulatorList(value)
        this.formulatorSearchTimer = null
      }, 300)
    },
    onFourthKeywordSearch() {
      this.getFourthList({ current: 1, pageSize: this.pagination.pageSize })
    },
    fourthKeyChange() {
      if (this.timer) { clearTimeout(this.timer); }
      this.timer = setTimeout(() => {
        this.getFourthList()
        this.timer = null;
      }, 300)
    },
    // 工厂配方列表查询
    getFourthList(pagination) {
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let params = {
        factoryId: window.localStorage.getItem('factoryId'),
        lineId: this.lineId,
        status: 0,
        // formulaType: 1,
        current,
        size: pageSize,
      }
      // 仅在选中配方师时才传 staffId
      if (this.formulatorId) {
        params.staffId = this.formulatorId
      }
      this.$http.get('/nhf-app/formulaManage/formulasPageByStaffId', { params }).then(res => {
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
          this.selectedRowKeys = Object.keys(this.selectedRowsMap)
        }
      })
    },
    /**
     * 获取工厂配方下拉列表（产线列表）
     */
    async fetchFourthSearchList() {
      try {
        const res = await this.$http.get('/nhf-core-data/line/list', { params: { current: 1, size: 10000 } })
        console.log('产线接口返回:', res)
        if (res.code === '0' || res.success) {
          this.fourthSearchList = res.data.records || []
          console.log('fourthSearchList:', this.fourthSearchList)
          console.log('第一条记录:', JSON.stringify(this.fourthSearchList[0]))
        }
      } catch (error) {
        console.error('获取产线列表失败:', error)
      }
    },
    /**
     * 获取配方师下拉列表
     */
    async fetchFormulatorList(name) {
      try {
        const factoryId = window.localStorage.getItem('factoryId')
        if (!factoryId) return
        const res = await this.$http.get('/iot-factory/factorystaff/selectFactoryStaffInfoPage', {
          params: { factoryId, current: 1, size: 10000, name }
        })
        if (res && (res.code === '0' || res.success)) {
          this.formulatorList = (res.data && res.data.records) || []
        }
      } catch (error) {
        console.error('获取配方师列表失败:', error)
      }
    },
    /**
     * 获取当前工厂下的用户角色，并控制"代工配方""关联配方""工厂配方"是否显示
     */
    async fetchUserRole() {
      try {
        const factoryId = window.localStorage.getItem('factoryId')
        if (!factoryId) {
          this.isOemVisible = false
          return
        }
        const res = await this.$http.get('/iot-factory/factorystaff/getStaffInfoByFactoryIdAndUserId', {
          params: { factoryId }
        })
        if (res && res.success && res.data) {
          const roleName = res.data.roleName
          this.isOemVisible = roleName === '(饲料BU)配方师'
          this.isLinkedVisible = roleName === '(饲料BU)配方师'
          // 如果是配方师，加载工厂配方产线列表和配方师列表
          if (this.isLinkedVisible) {
            this.fetchFourthSearchList()
            this.fetchFormulatorList()
          }
          // 如果不允许显示且当前选中为 oem，则切回 my，避免无效状态
          if ((!this.isOemVisible && this.selectedFormulaType === 'oem') || (!this.isLinkedVisible && this.selectedFormulaType === 'linked')) {
            this.selectedFormulaType = 'my'
          }
        } else {
          this.isOemVisible = false
          this.isLinkedVisible = false
        }
      } catch (e) {
        this.isOemVisible = false
        this.isLinkedVisible = false
      }
    }
  }
}
</script>
<style scoped>
.headForm {
  padding: 0;
  margin: 0;
}

.tableBox {
  padding: 0;
}

.formula-radio-group {
  width: 100%;
}

.formula-row {
  display: flex;
  align-items: center;
}

.formula-radio {
  margin-right: 0;
}

.formula-label {
  margin-left: 4px;
  font-size: 14px;
  color: #333;
}

/* 禁用状态的样式 */
.formula-row .ant-select-disabled .ant-select-selector {
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}

.formula-row .ant-input[disabled] {
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  color: #999;
}
</style>